import { Directive, HostListener } from "@angular/core";

@Directive({
    selector: '[onlyNumbers]'
})
export class OnlyNumbersDirective {

    @HostListener('keydown', ['$event'])
    onKeyDown(event: KeyboardEvent) {
        const key = event.key;

        // Permite teclas de control
        if (
            key === 'Backspace' ||
            key === 'Tab' ||
            key === 'ArrowLeft' ||
            key === 'ArrowRight'
            ) {
                return;
            }

        // Bloquea todo lo que no sea número
        if (!/^[0-9]$/.test(key)) {
            event.preventDefault();
        }
    }
}
